export enum AccountExchangeWithdrawStatus {
  CREATED = 'CREATED',
  EXCHANGED = 'EXCHANGED',
  FAILED = 'FAILED',
  DONE = 'DONE'
}
